var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 146,
    viewBox: "0 0 128 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 233.755,
    rx: 12.5,
    transform: "matrix(0.777146 0.62932 0.62932 -0.777146 -33.4985 134.418)",
    fill: "#ECA601"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftOrange);
export default __webpack_public_path__ + "static/media/LeftOrange.6bd6f5b68860d2b5a587eaec38421dc1.svg";
export { ForwardRef as ReactComponent };